import React, { useEffect } from 'react';

import AppTheme from "./components/AppTheme/AppTheme";
import { Box, CssBaseline, Stack, useTheme } from "@mui/material";
import SideMenu from "./components/SideMenu";
import AppNavbar from "./components/AppNavbar";
import BottomNav from "./components/BottomNav/BottomNav";
import { SocketProvider } from './context/SocketContext';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Dashboard from './pages/dashboard';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Search from "./pages/search";
import Login from './components/Auth/Login';
import { AuthProvider } from './context/AuthContext';
import ProtectedLayout from './components/ProtectedLayout';
import Reports from './pages/Reports';
import 'dayjs/locale/ro';
import { Toaster } from 'react-hot-toast';
import Administration from './pages/Administration';
import ClientAlertsPage from './pages/Administration/AdministrationPages/ClientAlerts';
import ConfirmAlert from './pages/ConfirmAlert';
import { Chart, registerables } from "chart.js";
import LocationAdministrationPage from './pages/Administration/AdministrationPages/LocationAdministration';
import IrrelevantEntriesPage from './pages/Administration/AdministrationPages/IrrelevantEntries';

export default function App(props: { disableCustomTheme?: boolean }) {
    const theme = useTheme();
    const location = useLocation();
    const isLoginPage = location.pathname === "/login";
    const isConfirmAlertPage = location.pathname === "/confirmAlert";

    useEffect(() => {
        Chart.register(...registerables);
    }, []);

    return (
        <AuthProvider>
            <SocketProvider>
                <AppTheme {...props}>
                    {/* todo use actual locale */}
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='ro'>
                        <CssBaseline enableColorScheme />
                        <Toaster />
                        <Box sx={{ display: 'flex', height: '100%' }}>
                            {!isLoginPage && !isConfirmAlertPage && <>
                                <SideMenu />
                                <AppNavbar />
                                <BottomNav />
                            </>}
                            <Box
                                component="main"
                                sx={{
                                    flexGrow: 1,
                                    overflow: 'auto',
                                    height: '100%',
                                }}
                            >
                                <Stack
                                    sx={{
                                        alignItems: 'center',
                                        mx: {
                                            xs: '10px',
                                            md: 2,
                                        },
                                        mt: isLoginPage || isConfirmAlertPage ? 0 : '80px',
                                        mb: isLoginPage || isConfirmAlertPage ? 0 : { xs: '72px', md: 2 },
                                        height: isLoginPage || isConfirmAlertPage
                                            ? '100%'
                                            : {
                                                xs: 'auto',
                                                md: `calc(100% - 80px - ${theme.spacing(2)})`,
                                            },
                                        minHeight: isLoginPage || isConfirmAlertPage
                                            ? undefined
                                            : { xs: 'calc(100% - 80px - 72px)', md: undefined },
                                    }}
                                >
                                    <Routes>
                                        <Route path="/login" element={<Login />} />
                                        <Route path="/confirmAlert" element={<ConfirmAlert />} />
                                        <Route
                                            path="/*"
                                            element={
                                                <ProtectedLayout>
                                                    <Routes>
                                                        <Route path="/dashboard" element={<Dashboard />} />
                                                        <Route path="/" element={<Dashboard />} />
                                                        <Route path="/search" element={<Search />} />
                                                        <Route path="/reports" element={<Reports />} />
                                                        <Route path="/administration" element={<Administration />} />
                                                        <Route path="/administration/location-administration" element={<LocationAdministrationPage />} />
                                                        <Route path="/administration/client-alerts" element={<ClientAlertsPage />} />
                                                        <Route path="/administration/irrelevant-entries" element={<IrrelevantEntriesPage />} />
                                                        <Route path="*" element={<Navigate to="/dashboard" />} />
                                                    </Routes>
                                                </ProtectedLayout>
                                            }
                                        />
                                    </Routes>
                                </Stack>
                            </Box>
                        </Box>
                    </LocalizationProvider>
                </AppTheme>
            </SocketProvider>
        </AuthProvider>
    );
}
